import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsOS() {
  const descriptionList = [
    "Besoin d’un système propre et performant ? Que ce soit pour une première installation ou pour repartir sur une base saine, nous nous occupons de l’installation du système d’exploitation de votre choix : Windows, macOS ou Linux.",
    "Ce service inclut la configuration initiale, l’installation des mises à jour et des pilotes, ainsi que l’optimisation des paramètres pour une utilisation fluide.",
    "Options supplémentaires : Transfert des données et installation de logiciels essentiels disponibles en supplément.",
  ];
  const deroulementList = [
    "1 Prise de rendez vous : Nous convenons d'un rendez vous à notre atelier avec votre ordinateur ou directement à votre domicile.",
    "2 Sauvegarde des données (si demandé) : Si vous souhaitez conserver vos fichiers, nous pouvons effectuer une sauvegarde avant la réinstallation (option payante).",
    "3 Installation du système d’exploitation : Formatage du disque et installation propre de Windows, macOS ou Linux.",
    "4 Mises à jour et pilotes : Installation des dernières mises à jour et des pilotes pour assurer la compatibilité matérielle.",
    "5 Optimisation et configuration : Réglage des paramètres pour améliorer la rapidité et la stabilité du système.",
    "6 (Optionnel) Restauration des fichiers et logiciels : Récupération des données et installation de vos logiciels essentiels (supplément).",
    "7 Tests et restitution : Vérification du bon fonctionnement du système avant de vous contacter pour la récupération de votre appareil.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="INSTALLATION ou RÉINSTALLATION DU SYSTÈME D'EXPLOITATION (Windows, Mac, Linux)"
        price="40€ TTC"
        atelier={true}
        domicile={true}
        time="2h - 4h"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="Le transfert des données et installation de logiciels essentiels est à 20€" />
    </div>
  );
}

export default TarifsOS;
